import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

function AuthenticatedNavbar({ activeTab, menuItems, toggleMobileMenu, isMobileMenuOpen }) {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
        <header className={`bg-[#0f172a] border-b border-slate-800/50 px-4 sm:px-8 fixed top-0 right-0 transition-all duration-300 flex items-center h-[72px] ${
            isMobileMenuOpen ? 'left-20 z-30' : 'left-0 z-50'
        } md:left-20 md:z-50`}>
            <div className="flex items-center justify-between w-full">
                <div className="flex items-center gap-4">
                    {/* Hamburger Menu Button - Mobile Only */}
                    <button
                        onClick={toggleMobileMenu}
                        className="md:hidden text-slate-400 hover:text-white transition-colors duration-200"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                    <h1 className="text-2xl font-bold text-white hidden md:block">
                        {menuItems.find(item => item.id === activeTab)?.label || 'Dashboard'}
                    </h1>
                </div>
                <div className="flex items-center">
                    {/* User Profile Dropdown */}
                    <div className="relative" ref={dropdownRef}>
                        <button
                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                            className="flex items-center gap-2 px-3 py-2 rounded-full hover:bg-slate-800/50 transition-all duration-200 group"
                        >
                            <div className="w-9 h-9 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-full flex items-center justify-center text-white font-semibold text-sm shadow-lg shadow-emerald-500/20 ring-2 ring-slate-700/50 group-hover:ring-emerald-500/30 transition-all duration-200">
                                {user?.email?.charAt(0).toUpperCase() || 'A'}
                            </div>
                            <svg 
                                className={`w-4 h-4 text-slate-500 group-hover:text-slate-400 transition-all duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`} 
                                fill="none" 
                                stroke="currentColor" 
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>

                        {/* Dropdown Menu */}
                        {isDropdownOpen && (
                            <div className="absolute right-0 mt-3 w-56 bg-gradient-to-br from-[#0f172a] to-[#020617] border border-slate-700/50 rounded-xl shadow-2xl shadow-black/50 overflow-hidden z-[60] animate-slideDown">
                                <div className="p-3 border-b border-slate-800/50">
                                    {/* <p className="text-sm font-semibold text-white truncate">{user?.name || 'Admin User'}</p> */}
                                    <p className="text-xs text-slate-400 truncate mt-0.5">{user?.email || 'Email not found.'}</p>
                                </div>
                                
                                <div className="py-1">
                                    {/* <button
                                        onClick={() => {
                                            setIsDropdownOpen(false);
                                            // Handle account settings navigation
                                        }}
                                        className="w-full flex items-center gap-3 px-4 py-2.5 text-left text-slate-300 hover:bg-slate-800/50 hover:text-white transition-colors duration-200"
                                    >
                                        <svg className="w-5 h-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                        </svg>
                                        <span className="text-sm font-medium">Account Settings</span>
                                    </button> */}
                                    
                                    {/* <div className="my-1 border-t border-slate-800/50"></div> */}
                                    
                                    <button
                                        onClick={handleLogout}
                                        className="w-full flex items-center gap-3 px-4 py-2.5 text-left text-red-400 hover:bg-red-500/10 hover:text-red-300 transition-colors duration-200"
                                    >
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                        </svg>
                                        <span className="text-sm font-medium">Logout</span>
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
        
        <style jsx>{`
            @keyframes slideDown {
                from {
                    opacity: 0;
                    transform: translateY(-10px);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }
            .animate-slideDown {
                animation: slideDown 0.2s ease-out forwards;
            }
        `}</style>
        </>
    );
}

export default AuthenticatedNavbar;

